module.exports = __webpack_public_path__ + "static/media/slidingSub3.4118b674.png";